import { useSubscriptionDeployment, DeploymentType } from "@/api";
import { useProxyAuthCookie } from "@/hooks/proxyAuthCookie";
import App from "./App";

interface Props {
  subscriptionId: string;
}

const SubscriptionApp = ({ subscriptionId }: Props) => {
  const { data, loading, error } = useSubscriptionDeployment({
    subscriptionId
  });
  const isProxyAuthCookieSet = useProxyAuthCookie();

  return (
    <App
      deploymentId={subscriptionId}
      deploymentType={DeploymentType.Subscription}
      releaseNotesBase64={
        data?.current?.appVersion.releaseNotes?.contentBase64 || undefined
      }
      userGuideBase64={
        data?.current?.appVersion.userGuide?.contentBase64 || undefined
      }
      error={error}
      loading={loading}
      isProxyAuthCookieSet={isProxyAuthCookieSet}
    />
  );
};

export default SubscriptionApp;
